import { ToDoList } from "./ToDoList";
import { PaymentIssues } from "./PaymentIssues";
import { RecentTrainingEvents } from "./RecentTrainingEvents";
import { UpcomingAppointments } from "./UpcomingAppointments";

import "./dashboard.scss";

export function Dashboard() {
	return (
		<div className="right-column-content-container">
			<div className="dashboard-container">
				<UpcomingAppointments />
				<RecentTrainingEvents />
				<PaymentIssues />
				<ToDoList />
			</div>
		</div>
	);
}
